import React from "react";
import ReactDOM from "react-dom/client";
import "./Services/axiosSetup";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { ThemeProvider } from "@geti/identidade-visual-react";
import { store } from "./Services/StoreConfig";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>
);
